import groq from 'groq'
export const MediaTypeQuery = groq`
_type == "MediaType" => {
  select,
  _type,
  _key,
  ...,
  videoObject {
    "video": video.asset->.url,
    "thumbnail": thumbnail.asset->.url
  },
  vimeoObject {
    size,
    vimeo
  },
  imageObject {
    aspectRatio,
    objectFit,
    size,
    image {
      ...,
      asset-> {
        ...,
        _id,
        url,
        _type,
        altText,
        description,
        title,
        metadata {
          blurHash,
          dimensions
        }
      }
    }
  }
}

`
